import isTouchDevice from '@flowgate/core/assets/app/utils/isTouchDevice';

import { DROPDOWN_MENU, VISIBLE } from './constants';

type DropdownOptions = {
  dropdown: Element;
  labelClassName: string;
  visibilityModifier?: string;
};

export const makeDropdownOutsideOverflow = ({
  dropdown,
  labelClassName,
  visibilityModifier,
}: DropdownOptions): void => {
  const $dropdown = $(dropdown);
  const $label = $(labelClassName, dropdown);
  const $menu = $(DROPDOWN_MENU, dropdown);
  const labelVisible = `${labelClassName}--${visibilityModifier || VISIBLE}`;
  $dropdown
    .on('show.bs.dropdown', () => {
      if (!isTouchDevice()) {
        $label.addClass(labelVisible);
      }
      const offset = $menu.offset();
      if (!offset) return;
      $('body').append(
        $menu
          .css({
            left: offset.left,
            position: 'absolute',
            top: offset.top,
          })
          .detach(),
      );
    })
    .on('hidden.bs.dropdown', () => {
      $dropdown.append($menu.css({ left: '', top: '' }).detach());
      if (!isTouchDevice()) {
        $label.removeClass(labelVisible);
      }
    });
};

export const initDropdowns = (): void => {
  for (const dropdown of document.getElementsByClassName('dropdown')) {
    if (dropdown.classList.contains('dropdown--overflow')) {
      makeDropdownOutsideOverflow({
        dropdown,
        labelClassName: 'dropdown-toggle__label',
      });
    }
  }
};
